import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {BehaviorSubject, Subject, Subscription} from 'rxjs';
import {debounceTime, map, switchMap, tap} from 'rxjs/operators';
import {UnitUnifiedSearchService} from './unit-unified-search.service';
import {AssignUnitToExecutorService} from './assign-unit-to-executor.service';
import {NotificationsService} from 'angular2-notifications';
import {TranslateService} from '@ngx-translate/core';
import {ExecutorModel} from '../../models/executor.model';
import {ExecutorPricePlanGroupListService} from './executor-price-plan-group-list.service';

@Component({
  selector: 'app-add-unit-to-executor',
  templateUrl: './add-unit-to-executor.component.html',
  styleUrls: ['./add-unit-to-executor.component.scss']
})
export class AddUnitToExecutorComponent implements OnInit, OnDestroy {
  @Input() executor: ExecutorModel;
  @Output() done: EventEmitter<'cancel' | 'success'> = new EventEmitter<'cancel' | 'success'>();
  formGroup: FormGroup = new FormGroup({
    unified_search_field: new FormControl(undefined, [Validators.required]),
    executor_price_plan_group_id: new FormControl(undefined, [Validators.required]),
  });
  public keyField: string;
  public displayedField: string;
  public units: BehaviorSubject<Array<any>> = new BehaviorSubject<Array<any>>(null);
  public pricePlanGroups: BehaviorSubject<Array<any>> = new BehaviorSubject<Array<any>>(null);
  public groupBy: ((item: any) => string) | string = null;
  public loading = false;
  public typeahead = new Subject<string>();
  public typeaheadSubscription: Subscription;
  public selected: number | null;
  private requestActive = false;
  private readonly pageSize = 50;

  constructor(
    private unitUnifiedSearchService: UnitUnifiedSearchService,
    private executorPricePlanGroupListService: ExecutorPricePlanGroupListService,
    private assignUnitToExecutorService: AssignUnitToExecutorService,
    private notif: NotificationsService,
    private translateService: TranslateService,
  ) { }

  ngOnInit() {
    this.typeaheadSubscription = this.typeahead.pipe(
      debounceTime(500),
      switchMap(
        text => {
          this.loading = true;
          return this.unitUnifiedSearchService.getUnits(text, this.getExecutor().project_id);
        }
      ),
      map(
        units => units.map(u => ({id: u.id, name: `${u.name} (imei: ${u.hw_id}) s/n: ${u.plate_number})`}))
      ),
      tap(() => this.loading = false)
    ).subscribe(
      response => this.units.next(response)
    );
    this.executorPricePlanGroupListService.getPricePlanGroups(this.getExecutor().project_id).subscribe(
      pricePlanGroups => this.pricePlanGroups.next(pricePlanGroups)
    );
  }

  ngOnDestroy() {
    [this.typeaheadSubscription].filter(s => !!s).forEach(s => s.unsubscribe());
  }

  closeFormEvent() {
    this.done.emit('cancel');
  }

  add() {
    if (this.selected && !this.requestActive) {
      this.requestActive = true;
      this.assignUnitToExecutorService.assign(
        this.formGroup.controls.unified_search_field.value,
        this.getExecutor().id,
        this.formGroup.controls.executor_price_plan_group_id.value,
      ).subscribe(
        result => {
          this.requestActive = false;
          this.notif.success(this.translateService.instant('Device successfully added'));
          this.done.emit('success');
        },
        error => {
          this.requestActive = false;
          this.notif.error('Server error');
        }
      );
    }
  }

  onUnitSelectValueChange(value) {
    this.selected = value;
  }
  onClear() {
    this.selected = null;
  }
  getExecutor() {
    return this.executor;
  }
}
